import { useState, useEffect } from 'react';
import Config from 'utils/getEnvConfig';

const fallbackImage = 'https://assets.crediblemind.com/images/cm-logo-blue.jpg';

const {
  EMBEDLY: { API_KEY },
} = Config;

export const getEmbedlyImageUrl = file => {
  if (!file) return null;
  const url = file.startsWith('//') ? `https:${file}` : file;
  if (
    url.startsWith('https://images.ctfassets.net/') ||
    url.startsWith('https://i-cdn.embed.ly/1/')
  )
    return url;
  return `https://i.embed.ly/1/display?url=${encodeURIComponent(
    url,
  )}&key=${API_KEY}&dnt=1`;
};

export const handleEmbedlyImageError = (e, originalUrl) => {
  if (e.target.src === fallbackImage) return;
  if (originalUrl && e.target.src !== originalUrl) {
    e.target.src = originalUrl;
  } else {
    e.target.src = fallbackImage;
  }
};

export const useEmbedlyImage = file => {
  const embedlyUrl = getEmbedlyImageUrl(file);
  const needsValidation = embedlyUrl && embedlyUrl.includes('i.embed.ly');
  const [src, setSrc] = useState(
    needsValidation ? file || fallbackImage : embedlyUrl || fallbackImage,
  );

  useEffect(() => {
    const url = getEmbedlyImageUrl(file);
    if (!url) {
      setSrc(fallbackImage);
      return;
    }
    if (!url.includes('i.embed.ly')) {
      setSrc(url);
      return;
    }

    fetch(url, { method: 'HEAD' })
      .then(res => {
        setSrc(res.ok ? url : fallbackImage);
      })
      .catch(() => {
        setSrc(fallbackImage);
      });
  }, [file]);

  return src;
};
